import { MENU_ITEM_2_CONSTANTS } from "./menuItem_2";

/** Navbar chrome for Menu Item 3*/
export const NAVBAR_5_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    background_color: "#ffffff",
    hamburger_icon: "",
    hamburger_icon_alt: "",
    logo_icon: "",
    logo_icon_alt: "",
    mobile_logo_icon: "",
    mobile_logo_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    nav_link_color: "",
    sticky_to_top: false,
    /** IIT lead modal purple; empty in API still resolves in NavBar3 */
    mobile_hamburger_background: "#291973",
    /** Mobile menu panel — distinct from the white top bar */
    mobile_menu_background: "",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Bar background (e.g. #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "show_hamburger",
      label: "Show Hamburger Menu on Mobile",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)",
      defaultValue: true,
    },
    {
      fieldName: "hamburger_icon",
      label: "Hamburger Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — defaults to icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hamburger_icon_alt",
      label: "Hamburger Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_icon",
      label: "Logo (desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Main logo",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_icon_alt",
      label: "Logo Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon",
      label: "Logo (mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — falls back to desktop logo",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon_alt",
      label: "Mobile Logo Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_cancel_icon",
      label: "Mobile Close Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_cancel_icon_alt",
      label: "Mobile Close Icon Alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "nav_link_color",
      label: "Default nav link color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for theme default",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top on scroll (sits below Header 4 when both sticky)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "mobile_hamburger_background",
      label: "Mobile — hamburger button background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #291973 when empty",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "mobile_menu_background",
      label: "Mobile menu panel background (when hamburger open)",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #f5f5f5 — empty uses light gray",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};

const EXTRA_BUTTON_STYLE_FIELDS = [
  {
    fieldName: "button_border_color",
    label: "Button border color",
    value: "",
    valueType: "string",
    filedType: "COLOR",
    placeholder: "Outline / solid border (optional)",
    required: false,
    defaultValue: "",
  },
  {
    fieldName: "button_font_size",
    label: "Button font size",
    value: "",
    valueType: "string",
    filedType: "INPUT",
    placeholder: "e.g. 14px, 0.875rem, 1rem",
    required: false,
    defaultValue: "",
  },
] as const;

export const MENU_ITEM_5_CONSTANTS = {
  ...MENU_ITEM_2_CONSTANTS,
  DEFAULT_ROW: {
    ...MENU_ITEM_2_CONSTANTS.DEFAULT_ROW,
    button_border_color: "",
    button_font_size: "",
    is_cta: false,
  },
  MENU_FIELDS_CONFIG: MENU_ITEM_2_CONSTANTS.MENU_FIELDS_CONFIG.flatMap(
    (field) => {
      if (field.fieldName === "url") {
        return [
          {
            ...field,
            placeholder:
              "/path or https://… (optional — ignored for clicks when Is CTA is on)",
          },
          {
            fieldName: "is_cta",
            label: "Is CTA",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder:
              "On = open lead capture popup instead of navigating (nav links & buttons)",
            required: false,
            defaultValue: false,
          },
        ];
      }
      if (field.fieldName === "text_color") {
        return [
          {
            ...field,
            label: "Text color",
            placeholder: "Nav links & button label color",
          },
        ];
      }
      if (field.fieldName === "button_color") {
        return [
          {
            ...field,
            label: "Button background color",
            placeholder: "Solid fill; leave empty for outline (Login) style",
          },
          ...EXTRA_BUTTON_STYLE_FIELDS,
        ];
      }
      return [field];
    },
  ),
  TREE_CONFIG: {
    ...MENU_ITEM_2_CONSTANTS.TREE_CONFIG,
    treeTitle: "Menu Item 3 — structure",
    formLabels: {
      ...MENU_ITEM_2_CONSTANTS.TREE_CONFIG.formLabels,
      addNew: "➕ Add menu link",
      edit: "✏️ Edit item",
    },
  },
};
